<template lang="pug">
.result
  g-header
  .banner-area
    broken-banner.banner(:width="338" :height="90")
  .title
    span あなた
    span の
    span 来
    span 世
    span 診断
  .shindan
    h2.shindan__title: span 診断結果
    p.shindan__pre {{ userName }}さんの来世は…
    p.shindan__content {{ resultName }}<br />でしょう。
  .share
    tweet-button(
      :url="shareUrl"
      :text="shareText"
      @click="sendTweetEvent"
    )
  .message
  .anim(ref="bgChangePoint1")
    .anim__yohaku
    .anim__noise
    img.anim__noise-gif--glitch(src="@/assets/images/result/glitch.gif")
    .anim__noise-gif--noise2
    .anim__intro
      | {{ userName }}ｻンのおｶｹﾞで
      br
      | ぼｸはそっちにikeる□縺＞縲。
    img.anim__gif--eye(src="@/assets/images/anim/eye.gif" ref="bgChangePoint2")
    img.anim__gif--big-eye(src="@/assets/images/anim/big_eye.gif")
    img.anim__gif--light(src="@/assets/images/anim/light.gif")
    img.anim__gif--tv(src="@/assets/images/anim/tv.gif")
    img.anim__gif--head(src="@/assets/images/anim/head.gif")
    .anim__overlay
    .anim__button
      .anim__button-label {{ userName }}さんｱReが鐚□
  .noise-area(ref="arigatouTrigger")
    .noise-area__title
      p.noise-area__broken-name
        span(v-for="c in (userName + 'さン')") {{ c }}
      p.noise-area__broken-thanks
        span あ
        span り
        span が
        span と
        span う
    .arigatou
      .arigatou__bg(:style="{ opacity: arigatouBgOpacity }")
      .arigatou__main
        arigatou-wave(:length="arigatouCount")
      .arigatou__over--top
        arigatou-wave(:length="arigatouCount - 150")
      .arigatou__over--bottom
        arigatou-wave(:length="arigatouCount - 300")
      .arigatou__over--left
        arigatou-wave(:length="arigatouCount - 450")
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import _ from "lodash";

import TweetButton from "@/components/TweetButton";
import GHeader from "@/components/GHeader";
import BrokenBanner from "@/components/BrokenBanner";
import ArigatouWave from "@/components/ArigatouWave";
import commonConfig from "@/mixin/commonConfig";
import { AUDIO_SRC } from "@/const/config";
import { audioApi } from "@/js/soundManager";

const ARIGATOU_DURATION = 5000;
const ARIGATOU_MAX_COUNT = 800;
const ARIGATOU_COUNT_EASING = v => {
  return Math.pow(v, 2);
};
const ARIGATOU_BG_EASING = v => {
  return Math.pow(v, 8);
};

export default {
  name: "result",
  data: () => {
    return {
      arigatouFlag: false,
      arigatouTime: 0,
      scrollProgress: 0
    };
  },
  components: {
    TweetButton,
    GHeader,
    BrokenBanner,
    ArigatouWave
  },
  mixins: [commonConfig],
  computed: {
    ...mapState(["userName", "isMovieActive"]),
    ...mapGetters(["resultName", "resultData"]),
	shareText() {
	  return `${this.userName}の来世は
${this.resultName}
に決まりました。


#あなたの鐔ｭЖ_診断 #世にも奇妙な物語

`;
	},
    arigatouProgress() {
      return this.arigatouTime / ARIGATOU_DURATION;
    },
    arigatouCount() {
      return Math.floor(
        ARIGATOU_MAX_COUNT * ARIGATOU_COUNT_EASING(this.arigatouProgress)
      );
    },
    arigatouBgOpacity() {
      return ARIGATOU_BG_EASING(this.arigatouProgress);
    },
    baseVolume() {
      const MIN = 0.1;
      const MAX = 1;
      return MIN + this.scrollProgress * (MAX - MIN);
    },
    noiseVolumes() {
      return [
        this.baseVolume * (1 - this.scrollProgress),
        this.baseVolume * this.scrollProgress
      ];
    }
  },
  methods: {
    ...mapActions([
      "startAnimBg",
      "resetAnimBg",
      "addBgNumber",
      "resetBgNumber"
    ]),
    sendTweetEvent() {
      gtag("event", "btn", {
        event_category: "diagnosis-twitter"
      });
    },
    initScrollWatcher() {
      const bgScrollTriggerArray = [
        this.$refs.bgChangePoint1,
        this.$refs.bgChangePoint2
      ];

      this._handleScroll = () => {
        if (this.arigatouFlag) return;
        this.fireUserError();
        const y = window.pageYOffset || document.documentElement.scrollTop;

        const triggerY = this.$refs.arigatouTrigger.offsetTop;
        this.scrollProgress = y / (triggerY - window.innerHeight * 0.5);

        if (this.scrollProgress >= 1) {
          this.arigatouFlag = true;
          this.initArigatouCounter();
        }

        if (!bgScrollTriggerArray[0]) return;
        const bgTriggerY =
          bgScrollTriggerArray[0].getBoundingClientRect().top + y;
        const bgScrollProgress = y / (bgTriggerY - window.innerHeight);

        if (bgScrollProgress >= 1) {
          bgScrollTriggerArray.shift();
          this.addBgNumber();
        }
      };
      window.addEventListener("scroll", this._handleScroll);
    },
    disposeScrollWatcher() {
      if (!this._handleScroll) return;
      window.removeEventListener("scroll", this._handleScroll);
    },
    initArigatouCounter() {
      this.startAnimBg();
      if (this._soundErrorLong) this._soundErrorLong.play();
      let startTime = -1;

      const loop = time => {
        if (startTime < 0) {
          startTime = time;
        }
        const currentTime = time - startTime;
        if (currentTime / ARIGATOU_DURATION < 1) {
          this.arigatouTime = currentTime;
          this._loop = requestAnimationFrame(loop);
        } else {
          this.arigatouTime = ARIGATOU_DURATION;
          this.stopAllSound();
          if (this._soundSwitchNoise) this._soundSwitchNoise.play();
          this.$emit("init-video");
        }
      };
      this._loop = requestAnimationFrame(loop);
    },
    disposeArigatouCounter() {
      if (!this._loop) return;
      cancelAnimationFrame(this._loop);
    },
    initSound() {
      Promise.all(
        _.map(
          [
            AUDIO_SRC.NOISE_NORMAL,
            AUDIO_SRC.NOISE_STRANGE,
            AUDIO_SRC.CHILD,
            AUDIO_SRC.ERROR,
            AUDIO_SRC.ERROR_LONG,
            AUDIO_SRC.SWITCH_NOISE
          ],
          src => audioApi.loadSound(src)
        )
      ).then(sounds => {
        [
          this._soundNoiseNormal,
          this._soundNoiseStrange,
          this._soundChild,
          this._soundError,
          this._soundErrorLong,
          this._soundSwitchNoise
        ] = sounds;
        this.initNoise();
        this.initChildVoice();
      });
    },
    initNoise() {
      const LOOP_TIME = [8, 12.9];

      const noises = [this._soundNoiseNormal, this._soundNoiseStrange];

      _.each(noises, (sound, i) => {
        sound.play({
          volume: this.noiseVolumes[i]
        });
      });
      this.setNoiseVolume();

      const loop = () => {
        _.each(noises, (sound, i) => {
          const time = sound.getCurrentTime();
          if (time >= LOOP_TIME[i]) {
            sound.play({
              volume: this.noiseVolumes[i],
              offset: time - LOOP_TIME[i]
            });
          }
        });
        requestAnimationFrame(loop);
      };
      requestAnimationFrame(loop);
    },
    setNoiseVolume() {
      if (!this._soundNoiseNormal || !this._soundNoiseStrange) return;
      this._soundNoiseNormal.setVolume(this.noiseVolumes[0]);
      this._soundNoiseStrange.setVolume(this.noiseVolumes[1]);
    },
    stopAllSound() {
      if (this._soundNoiseNormal) this._soundNoiseNormal.stop();
      if (this._soundNoiseStrange) this._soundNoiseStrange.stop();
      if (this._soundChild) this._soundChild.stop();
      if (this._soundError) this._soundError.stop();
      if (this._soundErrorLong) this._soundErrorLong.stop();
      if (this._soundSwitchNoise) this._soundSwitchNoise.stop();
    },
    initChildVoice() {
      setTimeout(() => {
        if (this.isMovieActive) return;
        if (this._soundChild)
          this._soundChild.play({
            volume: Math.pow(this.baseVolume, 2)
          });
        this.initChildVoice();
      }, 3000 + 5000 * Math.random());
    },
    fireUserError() {
      if (this._userErrorTimer) {
        clearTimeout(this._userErrorTimer);
        this.setUserErrorTimer();
      } else {
        if (this._soundError) {
          this._soundError.play({
            volume: Math.pow(this.baseVolume, 1.5)
          });
        }
        this.setUserErrorTimer();
      }
    },
    setUserErrorTimer() {
      this._userErrorTimer = setTimeout(() => {
        this._userErrorTimer = null;
      }, 1000);
    }
  },
  beforeRouteLeave(to, from, next) {
    // 動画の再生中はルーティングの移動をみとめない
    if (this.isMovieActive) {
      next(false);
    } else {
      next();
    }
  },
  watch: {
    scrollProgress: "setNoiseVolume"
  },
  mounted() {
    if (!this.resultName || !this.userName) {
      this.$router.push({ name: "top" });
      return;
    }
    this.initScrollWatcher();
    this.initSound();
  },
  destroyed() {
    this.disposeScrollWatcher();
    this.disposeArigatouCounter();
    this.resetAnimBg();
    this.stopAllSound();
    this.resetBgNumber();
  }
};
</script>

<style lang="scss" scoped>
.result {
  position: relative;
  background-color: #fff;
}

.banner-area {
  margin: 10px 0px;
  text-align: center;
}

.title {
  width: 500px;
  margin-top: 50px;
  margin-bottom: 30px;
  font-size: 60px;
  font-weight: bold;
  line-height: 1;
  transform-origin: 0% 0%;
  transform: scaleX(0.3) translateX(75%);
  span {
    display: inline-block;
    @include font-mincho;
    &:nth-child(2) {
      transform: rotate(180deg) translateY(10%);
    }
    &:nth-child(3),
    &:nth-child(5) {
      transform: translateY(-35%);
    }
    &:nth-child(4) {
      transform: translateY(-15%);
    }
  }
}

.button {
  display: block;
  width: 100px;
  height: 50px;
  margin: 30px auto;
  background-color: red;
}

.shindan {
  width: (642px / 2);
  margin: auto;
  padding-bottom: 60px;
  overflow: hidden;
  background-color: #9ff;
  text-align: center;
  font-size: 20px;
  line-height: (46 / 40);
}
.shindan__title {
  width: (642px / 2);
  height: (58px / 2);
  margin: 40px 0px;
  background-image: image-url("shindan-title@2x.png");
  background-size: contain;
  background-repeat: no-repeat;
  span {
    display: none;
  }
}
.shindan__pre {
  font-weight: bold;
  margin-bottom: 1em;
  animation: fadeIn 2s;
  animation-delay: 0.5s;
  animation-fill-mode: both;
}
.shindan__content {
  font-style: italic;
  animation: fadeIn 2s;
  animation-delay: 2s;
  animation-fill-mode: both;
}

.share {
  margin: 40px 0px;
  text-align: center;
}

.message {
  width: (750px / 2);
  height: (676px / 2);
  margin: auto;
  margin-top: 75px;
  margin-bottom: 10px;
  background-image: image-url("result/message@2x.png");
  background-repeat: no-repeat;
  background-size: contain;
}

.anim {
  position: relative;
  width: (750px / 2);
  height: (4930px / 2);
  background-color: #000;
  overflow: hidden;
  pointer-events: none;
}

.anim__yohaku {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100px;
  background-color: #fff;
}

.anim__noise,
.anim__overlay {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-size: contain;
}
.anim__noise {
  background-image: image-url("result/bug-noise@2x.png");
}
.anim__overlay {
  background-image: image-url("result/bug-overlay@2x.png");
}

.anim__noise-gif {
  position: absolute;
}
.anim__noise-gif--glitch {
  @extend .anim__noise-gif;
  top: 20px;
  left: 0;
  width: 100%;
  height: auto;
}
.anim__noise-gif--noise1 {
  @extend .anim__noise-gif;
  width: 100%;
  top: 500px;
  height: 175px;
  background-image: image-url("result/noise_1.gif");
  background-size: (750px / 2) (350px / 2);
}
.anim__noise-gif--noise2 {
  @extend .anim__noise-gif;
  width: 100%;
  bottom: 200px;
  height: 340px;
  background-image: image-url("result/noise_2.gif");
  background-size: (750px / 2) (100px / 2);
}

.anim__intro {
  position: absolute;
  top: 222px;
  left: 8px;
  right: 0;
  text-align: center;
  color: #fff;
  font-size: 16px;
  line-height: 30px;
  letter-spacing: -1px;
}

.anim__button {
  position: absolute;
  left: 109px;
  top: 345px;
  width: 142px;
  height: 50px;
  overflow: hidden;
}
.anim__button-label {
  white-space: nowrap;
  font-weight: bold;
  line-height: 1;
  transform-origin: 0% 0%;
  transform: translateX(12px) scale(0.7, 3.5);
}

.anim__gif {
  position: absolute;
  display: block;
  height: auto;
}
.anim__gif--eye {
  @extend .anim__gif;
  top: 1369px;
  left: -40px;
  width: 444px;
}
.anim__gif--big-eye {
  @extend .anim__gif;
  top: 1851px;
  left: 266px;
  width: 267px;
}
.anim__gif--light {
  @extend .anim__gif;
  top: 1748px;
  left: 117px;
  width: 243px;
}
.anim__gif--tv {
  @extend .anim__gif;
  top: 1981px;
  left: 11px;
  width: 245px;
}
.anim__gif--head {
  @extend .anim__gif;
  top: 2167px;
  left: -40px;
  width: 450px;
}

.noise-area {
  background-color: #000;
  padding: 10px;
  padding-bottom: 500px;
  overflow: hidden;
}
.noise-area__title {
  margin: 30px 0px;
  text-align: center;
  color: #f00;
  font-size: 20px;
  line-height: 30px;
  letter-spacing: 3px;
  font-weight: bold;
}
.noise-area__broken-name {
  span {
    display: inline-block;
    &:nth-child(2) {
      transform: translateY(-3px);
    }
    &:nth-child(3) {
      font-size: 30px;
    }
    &:nth-last-child(2) {
      font-size: 25px;
      transform: translateY(5px);
    }
    &:nth-last-child(1) {
      margin-left: -5px;
      transform: translateY(-3px) scaleX(0.5);
    }
  }
}
.noise-area__broken-thanks {
  span {
    display: inline-block;
    transform-origin: 0% 0%;
    &:nth-child(2) {
      margin-right: -8px;
      transform: scaleX(0.5) translateY(5px);
    }
    &:nth-child(3) {
      transform: scaleX(1.2) translateY(-5px);
    }
    &:nth-child(4) {
      transform: translateY(10px);
    }
  }
}

.arigatou {
  color: #f00;
  font-size: (30px / 2);
  line-height: (50 / 30);
  pointer-events: none;
}
.arigatou__bg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #f00;
}
.arigatou__over {
  position: fixed;
  top: 50%;
  left: 50%;
  width: 150%;
  height: 150%;
  line-height: 1.5;
  transform-origin: 50% 50%;
}
.arigatou__over--top {
  @extend .arigatou__over;
  transform: translate(-50%, -50%) rotate(-15deg);
  @include sp-layout {
    font-size: 35px;
  }
  @include pc-layout {
    font-size: 50px;
  }
}
.arigatou__over--bottom {
  @extend .arigatou__over;
  transform: translate(-50%, -50%) rotate(190deg);
  @include sp-layout {
    font-size: 35px;
  }
  @include pc-layout {
    font-size: 60px;
  }
}
.arigatou__over--left {
  @extend .arigatou__over;
  transform: translate(-50%, -50%) rotate(-90deg);
  @include sp-layout {
    width: 200%;
    font-size: 40px;
  }
  @include pc-layout {
    font-size: 70px;
  }
}
</style>
